<template>
    <div class='content'>
        <div class="con-1">
            <div class="con-2">{{ $t('content121') }}</div>
            <div class="con-3">
                {{ $t('content122') }}</div>
            <img :src="$i18n.locale == 'zh' ? require('@/assets/fangda2.png'):require('@/assets/en_fangda2.png')" class="com-img" alt="">
        </div>
        <div class="title">{{ $t('content123') }}</div>

        <div class="box-swon">
            <div class="div-box">
                <img src="@/assets/bizhong_icon@2x.png" class="con-4-img" alt="">
                <div class="div-title">{{ $t('content124') }}</div>
                <div class="con-5">
                    <img src="@/assets/Slice 31@2x.png" class="con-7" alt="">
                    <div class="text-18">{{ $t('content125') }}</div>
                </div>
                <div class="con-6">
                    <img src="@/assets/Slice 31@2x.png" class="con-7" alt="">
                    <div class="text-18">{{ $t('content126') }}</div>
                </div>
                <div class="con-6">
                    <img src="@/assets/Slice 31@2x.png" class="con-7" alt="">
                    <div class="text-18">{{ $t('content127') }}</div>
                </div>
            </div>
            <div class="div-box">
                <img src="@/assets/daozhang_icon@2x.png" class="con-4-img" alt="">
                <div class="div-title">{{ $t('content128') }}</div>
                <div class="con-6">
                    <img src="@/assets/Slice 31@2x.png" class="con-7" alt="">
                    <div class="text-18">{{ $t('content129') }}</div>
                </div>
                <div class="con-6">
                    <img src="@/assets/Slice 31@2x.png" class="con-7" alt="">
                    <div class="text-18">{{ $t('content130') }}</div>
                </div>

            </div>
            <div class="div-box">
                <img src="@/assets/gongzuoliang_icon@2x.png" class="con-4-img" alt="">
                <div class="div-title">{{ $t('content131') }}</div>
                <div class="con-6">
                    <img src="@/assets/Slice 31@2x.png" class="con-7" alt="">
                    <div class="text-18">{{ $t('content132') }}</div>
                </div>
                <div class="con-6">
                    <img src="@/assets/Slice 31@2x.png" class="con-7" alt="">
                    <div class="text-18">{{ $t('content133') }}</div>
                </div>
            </div>
        </div>

        <div class="box-two">
            <div>
                <div class="con-10">
                    <div class="con-11">{{ $t('content134') }}</div>

                    <div class="con-5">
                        <img src="@/assets/Slice 25@2x.png" class="con-11-img" alt="">
                        <div class="con-12">{{ $t('content135') }}</div>
                    </div>
                    <div class="con-13">
                        <img src="@/assets/Slice 25@2x.png" class="con-11-img" alt="">
                        <div class="con-12">{{ $t('content136') }}</div>
                    </div>
                    <div class="con-13">
                        <img src="@/assets/Slice 25@2x.png" class="con-11-img" alt="">
                        <div class="con-12">{{ $t('content137') }}
                        </div>
                    </div>
                    <div class="con-13">
                        <img src="@/assets/Slice 25@2x.png" class="con-11-img" alt="">
                        <div class="con-12">{{ $t('content138') }}</div>
                    </div>
                </div>
                <div>
                    <img :src="$i18n.locale == 'zh' ? require('@/assets/Slice 32@2x.png'):require('@/assets/en_Slice 32@2x.png')" class="con-14-img" alt="">
                </div>
            </div>
        </div>

        <div :class="$i18n.locale + '_box-four'">
            <div class="four-text">
                {{ $t('content139') }}
            </div>
            <div class="flex-box-174">
                <div :class="$i18n.locale + '_con-15'">
                    <img src="@/assets/tigong_icon1@2x.png" class="con-15-img" alt="">
                    <div :class="$i18n.locale + '_con-16'"> {{ $t('content140') }}</div>
                </div>
                <div :class="$i18n.locale + '_con-15'">
                    <img src="@/assets/tigong_icon2@2x.png" class="con-15-img" alt="">
                    <div :class="$i18n.locale + '_con-16'"> {{ $t('content141') }}</div>
                </div>
            </div>
            <div class="flex-box-175">
                <div :class="$i18n.locale + '_con-15'">
                    <img src="@/assets/tigong_icon3@2x.png" class="con-15-img" alt="">
                    <div :class="$i18n.locale + '_con-16'"> {{ $t('content142') }}</div>
                </div>
                <div :class="$i18n.locale + '_con-15'">
                    <img src="@/assets/tigong_icon4@2x.png" class="con-15-img" alt="">
                    <div :class="$i18n.locale + '_con-16'">{{ $t('content143') }}</div>
                </div>
            </div>
            <div class="flex-box-175">
                <div :class="$i18n.locale + '_con-15'">
                    <img src="@/assets/tigong_icon5@2x.png" class="con-15-img" alt="">
                    <div :class="$i18n.locale + '_con-16'">{{ $t('content144') }}</div>

                </div>
                <div :class="$i18n.locale + '_con-15'">
                    <img src="@/assets/tigong_icon6@2x.png" class="con-15-img" alt="">
                    <div :class="$i18n.locale + '_con-16'">{{ $t('content145') }}</div>
                </div>
            </div>
        </div>

        <div class="con-17">{{ $t('content146') }}</div>
        <div class="padd-box">
            <div class="flex-box-176">
                <div :class="$i18n.locale + '_padd-box-four'">
                    <img src="@/assets/jiejue_icon1@2x.png" class="con-17-img" alt="">
                    <div class="con-18">{{ $t('content147') }}</div>
                </div>
                <div  :class="$i18n.locale + '_padd-box-four1'">
                    <img src="@/assets/jiejue_icon2@2x.png" class="con-17-img" alt="">
                    <div class="con-18">{{ $t('content148') }}</div>
                </div>
            </div>
            <div class="flex-box-177">
                <div  :class="$i18n.locale + '_padd-box-four2'">
                    <img src="@/assets/jiejue_icon3@2x.png" class="con-17-img" alt="">
                    <div class="con-18">{{ $t('content149') }}</div>
                </div>
                <div :class="$i18n.locale + '_padd-box-four'">
                    <img src="@/assets/jiejue_icon4@2x.png" class="con-17-img" alt="">
                    <div class="con-18">{{ $t('content150') }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//import

export default {
    name: 'index_2',
    components: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    watch: {},
    methods: {

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
}
</script>
<style scoped>
.content{
  padding-top: 290px;
}
.con-1 {
    position: relative;
}

.con-2 {
    font-size: 82px;
    text-align: center;
    color: #333;
}

.con-3 {
    font-size: 72px;
    text-align: center;
    padding-bottom: 47px;
    color: #666666;
    margin-top: 50px
}

.btn-box {
    margin-top: 58px;
    text-align: center;
    display: flex;
    justify-content: center;
    margin-bottom: 49px;
    position: absolute;
    top: 375px;
    left: 360px;
}

.con-11-img {
    width: 60px;
    height: 60px;
}

.btn-blue {
    width: 132px;
    height: 44px;
    font-size: 18px;
    background-color: #4873FF;
    color: #fff;
    border-radius: 5px;
    line-height: 44px;
    text-align: center;
    margin-right: 12px;
    cursor: pointer;

}

.btn-we {
    width: 132px;
    height: 44px;
    font-size: 18px;
    background-color: #fff;
    color: #4873FF;
    cursor: pointer;
    border-radius: 5px;
    line-height: 44px;
    text-align: center;
    border: 1px solid #4873FF;
    margin-left: 12px;

}

.con-4-img {
    width: 180px;
    height: 180px;
}

.title {
    margin-top: 50px;
    text-align: center;
    color: #333333;
    font-size: 82px;
    font-weight: 600;
}

.box-swon {
    padding: 47px;
    /* height: 420px; */
    /* display: flex;
    justify-content: space-between;
    margin-top: 69px;
    margin-bottom: 27px; */
}

.con-img {
    width: 100%;
    height: 750px;
}

.div-box {
    border-radius: 50px 2px;
    box-shadow: 0 4px 24px 0 #E8EFFA;
    padding: 42px 51px 42px 38px;
    margin-bottom: 50px;
}

.con-17 {
    font-size: 82px;
    color: #333333;
    text-align: center;
    font-weight: 600;
    margin-top: 145px;
}

.con-11 {
    font-size: 82px;
    color: #333333;
    margin-bottom: 50px;
    font-weight: 600;
}

.div-box1 {
    width: 371px;
    margin: 0 44px;
    border-radius: 50px 2px;
    box-shadow: 0 4px 24px 0 #E8EFFA;
    padding: 42px 51px 42px 38px;
}

.con-10 {
    margin-top: 50px;
}

.div-title {
    color: #333333;
    font-size: 72px;
    line-height: 58px;
    margin: 28px 0 50px 0;

}

.con-18 {
    width: 600px;
    font-size: 72px;
    color: #666666;
    margin-top: 24px;
    position: absolute;
    right: 140px;
}

.con-12 {
    font-size: 72px;
    color: #333333;
    margin-left: 12px;
}

.con-13 {
    display: flex;
    align-items: center;
    margin-top: 50px;
}

.com-img {
    width: 100%;
    height: 100%;
}

.zh_con-15 {
    text-align: center;
    width: 50%;
    height: 600px;
    position: relative;
}
.en_con-15 {
    text-align: center;
    width: 50%;
    height: 1000px;
    position: relative;
}

.con-5 {
    display: flex;
    align-items: center;
}

.text-18 {
    font-size: 62px;
    color: #666666;
}

.con-7 {
    width: 60px;
    height: 60px;
    margin-right: 20px;
}

.con-17-img {
    width: 220px;
    height: 220px;
}


.con-15-img {
    width: 200px;
    height: 200px;
}



.con-14-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.zh_con-16 {
    width: 600px;
    font-size: 72px;
    color: #666666;
    position: absolute;
    right: 170px;
}

.en_con-16 {
    width: 700px;
    font-size: 72px;
    color: #666666;
    position: absolute;
    right: 100px;
}

.box-two {
    padding: 47px;
    /* height: 881px; */
}

.zh_box-four {
    padding: 47px;
    height: 2200px;
    background-color: #F8F9FF;
}

.en_box-four {
    padding: 47px;
    height: 3400px;
    background-color: #F8F9FF;
}

.con-6 {
    display: flex;
    align-items: center;
    margin-top: 20px;
}

.four-text {
    color: #333333;
    font-size: 82px;
    text-align: center;
    margin-bottom: 96px;
    font-weight: 600;
}

.flex-box-174 {
    display: flex;
    justify-content: space-between;

}

.flex-box-175 {
    display: flex;
    justify-content: space-between;
    margin-top: 91px;
}

.flex-box-176 {
    display: flex;
    justify-content: space-between;
    margin-top: 91px;
}

.flex-box-177 {
    display: flex;
    justify-content: space-between;
    margin-top: 91px;
}

.padd-box {
    padding-top: 56px;
}

.zh_padd-box-four {
    width: 49%;
    height: 700px;
    border-radius: 24px 2px;
    box-shadow: 0 4px 24px 0 #EBEFFA;
    padding: 48px 41px 41px 41px;
    text-align: center;
    position: relative;
}

.en_padd-box-four {
    width: 49%;
    height: 1200px;
    border-radius: 24px 2px;
    box-shadow: 0 4px 24px 0 #EBEFFA;
    padding: 48px 41px 41px 41px;
    text-align: center;
    position: relative;

}

.zh_padd-box-four1 {
    width: 49%;
    height: 700px;
    border-radius: 24px 2px;
    box-shadow: 0 4px 24px 0 #EBEFFA;
    padding: 48px 41px 41px 41px;
    position: relative;
    text-align: center;
}

.zh_padd-box-four2 {
    width: 49%;
    height: 700px;
    border-radius: 24px 2px;
    box-shadow: 0 4px 24px 0 #EBEFFA;
    padding: 48px 41px 41px 41px;
    position: relative;
    text-align: center;
}


.en_padd-box-four1 {
    width: 49%;
    height: 1200px;
    border-radius: 24px 2px;
    box-shadow: 0 4px 24px 0 #EBEFFA;
    padding: 48px 41px 41px 41px;
    position: relative;
    text-align: center;
}

.en_padd-box-four2 {
    width: 49%;
    height: 1200px;
    border-radius: 24px 2px;
    box-shadow: 0 4px 24px 0 #EBEFFA;
    padding: 48px 41px 41px 41px;
    position: relative;
    text-align: center;
}
</style>